var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTooltip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2113_58889)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.9375,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.084 10.8788V10.9547H9.39994V10.8788C9.41929 9.84767 9.72248 9.39221 10.4966 8.93042C11.3158 8.43699 11.8125 7.76012 11.8125 6.74165C11.8125 5.29934 10.6901 4.3125 9.0129 4.3125C7.47764 4.3125 6.23911 5.1918 6.1875 6.80491H7.58085C7.6389 5.86867 8.31623 5.45116 9.0129 5.45116C9.78698 5.45116 10.4062 5.95091 10.4062 6.74165C10.4062 7.40587 9.99341 7.87399 9.45155 8.19661C8.60006 8.71533 8.10335 9.22141 8.084 10.8788ZM7.87758 12.7892C7.87113 13.2826 8.29042 13.6812 8.79358 13.6875C9.29028 13.6812 9.70312 13.2826 9.70958 12.7892C9.70312 12.2958 9.29028 11.8909 8.79358 11.8909C8.29042 11.8909 7.87113 12.2958 7.87758 12.7892Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2113_58889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTooltip);
export default __webpack_public_path__ + "static/media/ic-tooltip.e0c39b49d49240de54c821ac19f412e3.svg";
export { ForwardRef as ReactComponent };